import isNil from 'lodash/isNil';
import type { FormatMessage } from '@atlassian/jira-shared-types/src/general.tsx';
import { MAX_GOAL_HOUR, INVALID_FORMAT } from '../../../constants';
import { EMPTY_JQL } from '../../../ui/constants';
import { durationToMilliseconds, durationToHumanReadable } from '../../duration';

export const validateDuration = (
	timeGoalValue = '',
	formatMessage: FormatMessage,
): string | undefined => {
	const inputValue = timeGoalValue.trim();
	if (inputValue.length > 0) {
		const ms = durationToMilliseconds(inputValue, formatMessage);
		if (Number.isNaN(ms) || isNil(ms) || ms < 0) {
			return INVALID_FORMAT;
		}
	}
	return undefined;
};

// upper bound at MAX_GOAL_HOUR
export const getMaxDuration = (timeGoalValueInMs: number): number =>
	Math.min(timeGoalValueInMs, MAX_GOAL_HOUR);

export const formatDurationOnSave = (goalDuration = '', formatMessage: FormatMessage) => {
	const timeGoalValueInMs = durationToMilliseconds(goalDuration.trim(), formatMessage);
	if (isNil(timeGoalValueInMs)) {
		return '';
	}
	return durationToHumanReadable(getMaxDuration(timeGoalValueInMs), formatMessage);
};

export const validateJql = (jql = '', isDefaultGoal = false): string | undefined => {
	// default goal will always have empty jql
	// no validation required if goal is default
	if (isDefaultGoal) {
		return undefined;
	}

	const inputValue = jql.trim();

	if (inputValue.length < 1) {
		return EMPTY_JQL;
	}

	return undefined;
};

export const validateGoal = (
	duration: string,
	jql: string,
	isDefaultGoal: boolean,
	formatMessage: FormatMessage,
) => {
	const durationFieldError = validateDuration(duration, formatMessage);

	if (!isNil(durationFieldError)) {
		return durationFieldError;
	}

	return undefined;
};
